// extracted by mini-css-extract-plugin
module.exports = {"root":"_1APGP","left":"jMq4W","right":"dEadC","small":"_IP5j","normal":"_2dhBG"};